import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms'

export function strongPasswordValidator(abstractControl: AbstractControl): ValidationErrors | null {
	const passwordControl = abstractControl as FormControl<string>

	if (!passwordControl || !passwordControl.value) {
		return null
	}

	const password = passwordControl.value

	const errors: ValidationErrors = {}

	// Check for at least 1 uppercase letter
	if (!/[A-Z]/.test(password)) {
		errors['missingUpperCase'] = { amount: 1 }
	}

	// Check for at least 1 lowercase letter
	if (!/[a-z]/.test(password)) {
		errors['missingLowerCase'] = { amount: 1 }
	}

	// Check for at least 3 numbers
	if ((password.match(/\d/g) || []).length < 3) {
		errors['missingNumbers'] = { amount: 3 }
	}

	// Check for at least 1 special character
	if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
		errors['missingSpecialCharacter'] = { amount: 1 }
	}

	// If any errors are present, return them
	return Object.keys(errors).length > 0 ? errors : null
}
